var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"b-content",class:{
        '-padded': _vm.data.padded,
        '-columns': _vm.data.columns
    }},[_c('div',{staticClass:"b-content__inner | t-cms",domProps:{"innerHTML":_vm._s(_vm.data.content)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }